import {Navigate, NonIndexRouteObject} from "react-router"
import {navigationStore, pmsCreateStore, pmsDetailStore, pmsOverviewStore, validationStore} from "../store";
import React from "react";
import {PmsApp} from "../components/app/PmsApp";
import {ErrorPage} from "../components/page";


const pms: NonIndexRouteObject[] = [
    {
        path: `/pms`,
        element: <PmsApp mode={'overview'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            const searchParams = new URL(request.url).searchParams
            pmsOverviewStore.page = parseInt(searchParams.get("page") || "") || 1
            pmsOverviewStore.size = parseInt(searchParams.get("size") || "") || 25

            pmsOverviewStore.load().finally()
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/pms/create`,
        element: <PmsApp mode={'create'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            validationStore.reset()
            pmsCreateStore.reset()

            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/pms/:id`,
        element: <PmsApp mode={'detail'}/>,
        errorElement: <Navigate to={`/pms`} replace={true}/>,
        loader: async ({params, request}) => {
            validationStore.reset()
            pmsDetailStore.reset()

            pmsDetailStore.id = params.id!!
            const result = await pmsDetailStore.load()
            if (!result) {
                throw Error
            }

            navigationStore.setActivePath(request)
            return null
        }
    },
]

export {
    pms
}
